import React, { useId } from "react";
import { GlobeIcon } from "lucide-react";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
import { countryName } from "../utils/prices";
import type { CountryDetection, CountryPreference } from "../types/market";
const options: {
  value: CountryPreference;
  label: string;
}[] = [{
  value: "auto",
  label: "Automático"
}, {
  value: "AR",
  label: "Argentina"
}, {
  value: "MX",
  label: "México"
}, {
  value: "CO",
  label: "Colombia"
}, {
  value: "CL",
  label: "Chile"
}, {
  value: "PE",
  label: "Perú"
}, {
  value: "INTL",
  label: "Internacional (USD)"
}];
const sourceLabels: Record<string, string> = {
  "ip-country-is": "IP · country.is",
  "ip-ipapi": "IP · ipapi.co",
  language: "idioma del navegador"
};
export function CountrySelector() {
  const id = useId();
  const {
    preference,
    setPreference,
    urlOverride,
    detection,
    market,
    showDiagnostics
  } = useLocalizedPrices();
  const selected: CountryPreference = urlOverride ? options.find(o => o.value === urlOverride)?.value ?? "INTL" : preference;
  return <div className="mt-5 border-t border-cocoa-900/10 pt-4 text-center" data-id="element-61" data-mp="10z6vudpwqi67">
      <div className="flex items-center justify-center gap-2" data-id="element-62" data-mp="w4195cookzh2">
        <GlobeIcon className="h-3.5 w-3.5 shrink-0 text-caramel-600" aria-hidden="true" data-id="element-63" data-mp="19u4rvtocqb1r" />
        <label htmlFor={id} className="text-xs font-medium text-cocoa-700" data-id="element-64" data-mp="152mpd16ok2eo">
          Ver precios para
        </label>
        <select id={id} value={selected} onChange={e => setPreference(e.target.value as CountryPreference)} className="rounded-full border border-cocoa-900/20 bg-cream-50 py-1 pl-3 pr-7 text-xs font-semibold text-cocoa-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-caramel-500" data-id="element-65" data-mp="1jqzr6esg8fh3">
          {options.map(o => <option key={o.value} value={o.value} data-id="element-66" data-mp="3ujkesdkg9fm4">
              {o.label}
            </option>)}
        </select>
      </div>
      {showDiagnostics && <p className="mt-1 text-[11px] leading-snug text-cocoa-600" role="status" data-id="element-67" data-mp="3qkv3cqiz2854">
          {describeDiagnostics(detection, urlOverride, preference, market.currency)}
        </p>}
    </div>;
}
function describeDiagnostics(detection: CountryDetection, urlOverride: string | null, preference: CountryPreference, currency: string): string {
  const auto = detection.source === "pending" ? "Detectando país…" : detection.country ? `País detectado: ${countryName(detection.country)} (${sourceLabels[detection.source] ?? detection.source})` : "No se detectó país";
  if (urlOverride) return `Forzado por URL: ${countryName(urlOverride)} · ${currency} · ${auto}`;
  if (preference !== "auto") return `Selección manual · ${currency} · ${auto}`;
  return `${auto} · ${currency}`;
}